import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { concat, from, Observable, of } from "rxjs";
import { concatMap, skipWhile, take } from "rxjs/operators";

/**
 * This guard should be used by routes where the order of guard checking should be sequential.
 */

export class SequentialGuard implements CanActivate {
	constructor(private guards: CanActivate[]) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
		if (this.guards.length === 0) {
			return of(true);
		}

		const guards$ = from(this.guards).pipe(
			concatMap((guard) => {
				const val$ = guard.canActivate(route, state);
				if (val$ instanceof Observable) {
					return val$.pipe(take(1));
				}
				if (val$ instanceof Promise) {
					return val$;
				}

				return of(val$);
			}),
			skipWhile((value) => value === true),
			take(1)
		);

		return concat(guards$, of(true)).pipe(take(1));
	}
}

export function sequentialGuardFactory(...args: CanActivate[]) {
	return new SequentialGuard(args);
}
